const fileNameFromPath = path => path.substr(path.lastIndexOf("/") + 1);
const fileExtensionFromPath = path => path.substr(path.lastIndexOf(".") + 1);
const directoryFromPath = path => path.substr(0, path.lastIndexOf("/"));

export default {
  fileNameFromPath,
  fileExtensionFromPath,
  directoryFromPath
};
